var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 4.87781C7.54286 4.87781 3.50879 8.91188 3.50879 13.8689C3.50879 18.826 7.54286 22.8704 12.4999 22.8704C17.4569 22.8704 21.491 18.8363 21.491 13.8793C21.491 8.92225 17.4569 4.87781 12.4999 4.87781ZM13.2777 13.5371C13.2777 13.9623 12.9251 14.3148 12.4999 14.3148C12.0747 14.3148 11.7221 13.9623 11.7221 13.5371V8.35188C11.7221 7.9267 12.0747 7.5741 12.4999 7.5741C12.9251 7.5741 13.2777 7.9267 13.2777 8.35188V13.5371Z",
    fill: "#FF4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4971 3.63334H9.50301C9.0882 3.63334 8.75635 3.30149 8.75635 2.88668C8.75635 2.47186 9.0882 2.12964 9.50301 2.12964H15.4971C15.9119 2.12964 16.2438 2.46149 16.2438 2.87631C16.2438 3.29112 15.9119 3.63334 15.4971 3.63334Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.fed8f8e6cf7a5511820e69a290dfd38a.svg";
export { ForwardRef as ReactComponent };